'use client'
import { Button } from '@achieve/ascend'

function StateCTASection({ eyebrow, title, subtitle, buttonText, buttonUrl, disclaimer }) {
  return (
    <section className="mx-auto max-w-7xl px-5 pb-12 md:px-6 md:pb-16">
      <div className="border-t border-gray-300">
        {/* Eyebrow */}
        {eyebrow && (
          <p className="text-xs font-semibold uppercase tracking-wider text-gray-600 mb-2">
            {eyebrow}
          </p>
        )}

        {/* Title */}
        {title && <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">{title}</h2>}

        {/* Subtitle */}
        {subtitle && <p className="text-base text-gray-700 mb-6">{subtitle}</p>}

        {/* Button */}
        {buttonText && (
          <div className="mb-8">
            <Button
              variant="contained"
              color="primary"
              href={buttonUrl || '#'}
              className="bg-blue-700! hover:bg-blue-800! text-white! font-semibold! py-2.5! px-6! rounded-md! text-sm! normal-case!"
            >
              {buttonText}
            </Button>
          </div>
        )}

        {/* Divider */}
        <hr className="border-t-[0.75px] border-[#C0CBD8] my-8 max-w-7xl mx-auto" />

        {/* Disclaimer */}
        {disclaimer && (
          <div className="flex justify-center items-center">
            <div className="flex w-full max-w-[858px] py-8 px-2.5 justify-center items-start gap-2.5 bg-blue-50 border border-blue-200 rounded-sm">
              <p
                className="w-full max-w-[762px] text-base text-center font-normal leading-[140%] shrink-0"
                style={{ color: '#3B6AF7' }}
              >
                {disclaimer}
              </p>
            </div>
          </div>
        )}
      </div>
    </section>
  )
}

export { StateCTASection }
export default StateCTASection
